
export function useGetValidatedFields(requiredFields, modelProp) {

    let requiredField = false;

    if(requiredFields) {

        requiredFields.forEach(item => {

            if (item.modelName === modelProp) {

                requiredField = item.validate

            }
        });
    }

    return requiredField;
}


